module.exports = __webpack_public_path__ + "static/media/drawer_profile_inactive.57c0c251.svg";